import React, { createContext, ReactNode, useContext, useMemo } from 'react';

import { useApiView } from '@futrli/views/hooks/useApiView';
import { UsersView } from '@futrli/views/views/users/UsersView/UsersView';

import { useUserForm } from '../../user-form/hooks/use-user-form';

interface InviteUserContextProps {
  children?: ReactNode;
  workspaceId: string;
}

interface InviteUserContextValues {
  form: ReturnType<typeof useUserForm>;
  view: ReturnType<typeof useApiView<UsersView>>;
}

const defaultState = ({} as unknown) as InviteUserContextValues;

export const InviteUserContext = createContext(defaultState);

export const InviteUserContextProvider = ({ children, workspaceId }: InviteUserContextProps) => {
  const view = useApiView(useMemo(() => new UsersView(workspaceId), [workspaceId]));
  const form = useUserForm({ organisations: view.state.eligibleOrganisations, roles: view.state.roles });

  const values: InviteUserContextValues = {
    form,
    view
  };

  return <InviteUserContext.Provider value={values}>{children}</InviteUserContext.Provider>;
};

export const useInviteUserContext = () => useContext(InviteUserContext);
